import React, { useEffect, useState } from 'react';
import { getBranches, createBranch, updateBranch, deleteBranch } from '../api';
import styles from './Page.module.css';

const emptyForm = { name: '', city: '', address: '', phone: '', location: '' };

export default function BranchesPage() {
  const [branches, setBranches] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { fetchBranches(); }, []);

  const fetchBranches = async () => {
    const res = await getBranches();
    setBranches(res.data);
  };

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editId) {
        await updateBranch(editId, form);
        setMsg('Branch updated successfully!');
      } else {
        await createBranch(form);
        setMsg('Branch added successfully!');
      }
      setForm(emptyForm);
      setEditId(null);
      fetchBranches();
      setTimeout(() => setMsg(''), 3000);
    } catch {
      setMsg('Operation failed.');
    }
    setLoading(false);
  };

  const handleEdit = (b) => {
    setEditId(b.id);
    setForm({
      name: b.name || '',
      city: b.city || '',
      address: b.address || '',
      telephone: b.phone || '',
      location: b.location || '',
    });
    window.scrollTo(0, 0);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this branch?')) return;
    try {
      await deleteBranch(id);
      fetchBranches();
    } catch {
      alert('Failed to delete. Branch may have linked doctors or departments.');
    }
  };

  return (
    <div>
      <h2 className={styles.heading}>🏢 Manage Branches</h2>
      <div className={styles.grid}>
        <div className={styles.card}>
          <h3>{editId ? 'Edit Branch' : 'Add New Branch'}</h3>
          <form onSubmit={handleSubmit}>
            <div className={styles.field}>
              <label>Branch Name *</label>
              <input name="name" value={form.name}
                onChange={handleChange}
                placeholder="e.g. Jayanagar Branch" required />
            </div>
            <div className={styles.field}>
              <label>City *</label>
              <input name="city" value={form.city}
                onChange={handleChange}
                placeholder="e.g. Bengaluru" required />
            </div>
            <div className={styles.field}>
              <label>Address</label>
              <input name="address" value={form.address}
                onChange={handleChange}
                placeholder="e.g. 44/54, 30th Cross, Jayanagar" />
            </div>
            <div className={styles.field}>
              <label>Telephone</label>
              <input name="telephone" value={form.telephone}
                onChange={handleChange}
                placeholder="e.g. 080-26563579" />
            </div>
            <div className={styles.field}>
              <label>Location / Area</label>
              <input name="location" value={form.location}
                onChange={handleChange}
                placeholder="e.g. Jayanagar, South Bengaluru" />
            </div>
            {msg && <p className={styles.msg}>{msg}</p>}
            <div className={styles.btnRow}>
              <button type="submit" className={styles.btn} disabled={loading}>
                {loading ? 'Saving...' : editId ? 'Update Branch' : 'Add Branch'}
              </button>
              {editId && (
                <button type="button" className={styles.btnOutline}
                  onClick={() => { setEditId(null); setForm(emptyForm); }}>
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className={styles.card}>
          <h3>All Branches ({branches.length})</h3>
          <div className={styles.list}>
            {branches.map(b => (
              <div key={b.id} className={styles.item}>
                <div>
                  <strong>{b.name}</strong>
                  <span>📍 {b.address}{b.city ? `, ${b.city}` : ''}</span>
                  <span>📞 {b.phone || '—'}</span>
                </div>
                <div className={styles.actions}>
                  <button className={styles.editBtn}
                    onClick={() => handleEdit(b)}>✏️ Edit</button>
                  <button className={styles.deleteBtn}
                    onClick={() => handleDelete(b.id)}>🗑️ Delete</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
